var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-main-container"},[_c('div',{staticClass:"section-links"},_vm._l((_vm.menu),function(item){return _c('div',{key:item.id,staticClass:"mb-2"},[_c('p',{class:[
					'title-section-links',
					{ 'loading loading-dark': _vm.indeterminate } ]},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_vm._l((item.details),function(link){return _c('ul',{key:link.id},[_c('li',{class:[
						'section-link',
						{ 'loading': _vm.indeterminate } ],on:{"click":function($event){_vm.goToHelp(item, link)}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(link.name)+"\n\t\t\t\t")])])})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e648b744","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/section-links.vue
// module id = 970
// module chunks = 7 23